import type { UserManagerSettings } from 'oidc-client-ts';
import { getAppConfig } from '../config/appConfig';

export function createAuthConfig(): UserManagerSettings {
  const config = getAppConfig();
  
  return {
    authority: config.oidcAuthority,
    client_id: config.oidcClientId,
    redirect_uri: `${window.location.origin}/auth-callback`,
    silent_redirect_uri: `${window.location.origin}/silent-renew`,
    post_logout_redirect_uri: `${window.location.origin}/logout-callback`,
    response_type: 'code',
    scope: 'profile openid email basic',
    automaticSilentRenew: true,
  };
}

// Re-export as authConfig for backward compatibility
export { createAuthConfig as authConfig };
